import styled from '@emotion/styled';
import { Box, Card, Divider, Typography } from '@mui/material'
import axios from 'axios';
import React, { useEffect, useState } from 'react'

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

const CardWidget = styled("Card") (({ bgColor, color }) => ({
    backgroundColor: bgColor,
    border: `1px solid ${color}`,
    boxSizing: `border-box`,
    borderRadius: `22px`,
    width: '100%', // Set the width to 90% of the parent container
    height: '100%', // Automatically adjust the height based on content
    margin: '0 auto', // Center the card horizontally
    padding: '16px',
    //width: `225px`,
    //height: `126px`,
    //padding: '16px',
    //position: `absolute`,
    //left: `0px`,
    //top: `0px`,
    display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  }));

  const Text = styled("div")({
    textAlign: `left`,
    whiteSpace: `pre-wrap`,
    fontSynthesis: `none`,
    color: `rgba(0, 0, 0, 1)`,
    fontStyle: `normal`,
    fontFamily: `Inters-Medium`,
    fontWeight: `600`,
    fontSize: `24px`,
    letterSpacing: `0px`,
    textDecoration: `none`,
    lineHeight: `105.50000667572021%`,
    textTransform: `none`,
  });

  const Text2 = styled("div")({
    textAlign: `left`,
    whiteSpace: `pre-wrap`,
    fontSynthesis: `none`,
    color: `#777777`,
    fontStyle: `normal`,
    fontFamily: `Inters-Medium`,
    fontWeight: `500`,
    fontSize: `14px`,
    letterSpacing: `0px`,
    textDecoration: `none`,
    //lineHeight: `105.50000667572021%`,
    textTransform: `none`,
  });

  const Text3 = styled("div")({
    textAlign: `left`,
    whiteSpace: `pre-wrap`,
    fontSynthesis: `none`,
    color: `#000000`,
    fontStyle: `normal`,
    fontFamily: `Inters-Medium`,
    fontWeight: `500`,
    fontSize: `21px`,
    letterSpacing: `0px`,
    textDecoration: `none`,
    //lineHeight: `105.50000667572021%`,
    textTransform: `none`,
  });

  const Number = styled("div") (({ bgColor, color }) =>({
    textAlign: `left`,
    whiteSpace: `pre-wrap`,
    fontSynthesis: `none`,
    color: color,
    fontStyle: `normal`,
    fontFamily: `Bebas Neue`,
    fontWeight: `400`,
    fontSize: `142px`,
    letterSpacing: `0px`,
    textDecoration: `none`,
    lineHeight: `105.50000667572021%`,
    textTransform: `none`,
  }));

  const Image = styled("img") ({
    height: `39px`,
    width: `34px`,

}) 

function StudentDaysWidget({bgColor, color}) {
  const studentId = localStorage.getItem('studentId');
  const [testData, setTestData] = useState([]);

  useEffect(() => {
    // Make an API request to fetch test date data
    axios.get(`${API_ENDPOINT}studentdashboard/getremainingtestdate/${studentId}`)
      .then(response => {
        if(response.status === 200){
          setTestData(response.data)
          } else if(response.status === 403){
            setTestData([])
          } else {
            console.log('Error fetching timeline data:', response);
          }
      })
      .catch(error => {
        console.error('Error fetching test date data:', error);
      });
  }, []);

  console.log(testData);
  console.log(studentId)

  return (
    <CardWidget bgColor={bgColor} color={color}>
    <Box container spacing={2} display='flex' alignItems="center" justifyContent="center" height="100%">
      
      <Box>
        <Number color={color}>{testData.length > 0 ? testData[0].remaining_day : '0'}</Number>
      </Box>
      <Box>
        <Text>{testData.length > 0 ? 'Days Remaining' : 'No data available'}</Text>
      </Box>
    </Box>
    <Divider variant="middle" style={{ borderTop: '1px dashed grey', marginTop: '8px', marginBottom: '8px' }} />
    <Box container spacing={2} display='flex' alignItems="center" justifyContent="center" height="100%">
    <Box>
    <Image src='/studentdashboard_icons/calender.svg' />
    </Box>
    <Box>
        <Text2>Test Date</Text2>
        <Text3>{testData.length > 0 ? testData[0].test_date : 'No data found'}</Text3>
    </Box>
    </Box>

  </CardWidget>
  )
}

export default StudentDaysWidget